import {
  ProductTitleDocument,
  WineTitleDocument,
  useWineTitleQuery,
} from 'api/hooks'
import { client } from 'utils/apollo'

export const getWineTitle = wine => {
  const tradeNameBrand = wine?.tradeNameBrand
  const keyWords = wine?.keyWords ?? ''
  // prettier-ignore
  const specialClassifications = (wine?.specialClassifications || []).map(item => item?.name)

  return [tradeNameBrand, keyWords, ...specialClassifications]
    .filter(Boolean)
    .join(' ')
}

export const useWineTitle = id => {
  const { data } = useWineTitleQuery({
    variables: { id },
    fetchPolicy: 'cache-and-network',
    skip: !id,
  })
  const wine = data?.wine

  if (!wine) return ''

  return getWineTitle(wine)
}

export const productNameLoader = async ({ params }) => {
  const response = await client.query({
    query: ProductTitleDocument,
    variables: {
      slug: params.slug,
    },
  })

  if (!response.data) {
    return {
      title: '',
    }
  }

  return {
    title: getWineTitle(response.data.productBySlug?.wine),
  }
}

export const wineNameLoader = async ({ params }) => {
  const response = await client.query({
    query: WineTitleDocument,
    variables: {
      id: params.id,
    },
  })

  if (!response.data) {
    return {
      title: '',
    }
  }

  return {
    title: getWineTitle(response.data.wine),
  }
}
